const ContentfulEntry = ({ node, renderEmbeddedEntry, renderingLevel }) => {
	const contentType = node?.data?.target?.sys?.contentType?.sys?.id;
	if (typeof renderEmbeddedEntry === "function") {
		return renderEmbeddedEntry(contentType, node?.data?.target?.fields, renderingLevel);
	}
	return null;
};

export default ContentfulEntry;
